import { AutenthContext } from "components/context/Auth";
import { useContext } from "react";

export function useAuth() {
    const {token} = useContext(AutenthContext)
    return {token}
}